module.exports = __webpack_public_path__ + "static/media/wizualizacja-8.db3a7536.png";